import type { FaireThemeEntity } from "../../entity_types/theme";

export const discovery_theme_seasonal_florals: FaireThemeEntity = {
  token: "discovery_theme_seasonal-florals",
  type: "theme",
  retailerToken: "r_discovery",
  name: "Seasonal Florals & Botanicals",
  description: "Blooms and botanicals for every season",
  bgColor: "#E0F0D8",
  productTokens: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
